<template>
    <div class="main">
       
        <el-form @submit.native.prevent="onSubmitReclassificar" :model="formReclassificacao" ref="formReclassificacao" label-position="top">

            <template v-if="propTipoEnsino != 3">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Curso Nacional" prop="referencia_nacional" :rules="[$requiredChange]" key="referencia_nacional">
                            <el-select v-model="formReclassificacao.referencia_nacional" @change="getTurmas()">
                                <el-option v-for="(curso, i) in cursosNacionais" :key="i" :label="curso.nome" :value="curso.referencia_nacional"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Turma" prop="turma_id" :rules="[$requiredChange]" key="turma_id">
                            <el-select v-model="formReclassificacao.turma_id">
                                <el-option-group v-for="(curso, i) in selectTurmas" :key="i" :label="i">
                                    <template v-for="item in curso">
                                    <el-option :key="item.id" :label="item.vagas_disponiveis" :value="item.id"></el-option>
                                    </template>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>
            <template v-else>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Turma AEE" prop="turma_id" :rules="[$requiredChange]" key="turma_id">
                            <el-select v-model="formReclassificacao.turma_id">
                                <el-option v-for="(item, i) in selectTurmas" :key="i" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item class="u-text-right u-mt-15">
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>

export default {
    props: ['propMatricula', 'propInstituicaoId', 'propReferenciaNacional', 'propPeriodoLetivoId', 'propTipoEnsino', "propDataNascimento", "propAlunoId", "propTurmaAtual"],
    data: () => ({
        cursos: [],
        formReclassificacao: {
            referencia_nacional: '',
            turma_id: '',
            matricula_id: '',
            instituicao_id: '',
            turma_atual: '',
        },
        selectInstituicoes: [],
        selectTurmas: [],
        cursosNacionais: [],
        matricula: {}
    }),
    mounted(){
        
        this.formReclassificacao.matricula_id = this.propMatricula;
        this.formReclassificacao.turma_atual = this.propTurmaAtual;
        this.formReclassificacao.instituicao_id = this.propInstituicaoId;        

        this.getRefNacional();  

    },
    methods:{
        getRefNacional(){       

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/curso/getRefNacionalByInstituicao`, {i: this.propInstituicaoId,  p: this.propPeriodoLetivoId, referencia_nacional: this.propReferenciaNacional }, this.$store.getters.getHeaderAuth).then(response => {

                this.cursosNacionais = JSON.parse(JSON.stringify(response.data));

                this.formReclassificacao.referencia_nacional = this.propReferenciaNacional;

                this.getTurmasRegulares();

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getTurmasRegulares(){

            if(!this.formReclassificacao.referencia_nacional){

                return false;
            }

            window.eventBus.$emit('loading', true);

            let dados = {
                instituicao_id: this.propInstituicaoId, 
                periodo_letivo_id: this.propPeriodoLetivoId, 
                referencia_nacional: this.formReclassificacao.referencia_nacional
            };

            if(this.propAlunoId){
                dados['aluno_id'] = this.propAlunoId;
            }

            if(this.propDataNascimento){
                dados['data_nascimento'] = this.propDataNascimento;
            }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/getAllByReferenciaNacional`, dados, this.$store.getters.getHeaderAuth).then(response => {

                this.formReclassificacao.turma_id = '';
                this.selectTurmas = response.data.turmas;
                window.eventBus.$emit('loading', false);

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },        
        onSubmitReclassificar(){

            this.$refs.formReclassificacao.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/reclassificarMatricula`, this.formReclassificacao, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.throw !== 'undefined'){

                        window.eventBus.$emit('loading', false);

                        // window.eventBus.$emit('throw', response.data.throw.msg);

                        this.$alert(response.data.throw.msg, 'Atenção!', { dangerouslyUseHTMLString: true, confirmButtonText: 'OK' }).then(() => { }).catch(() => { });

                        // window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('onSubmitReclassificacao');
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});

        },
    },
    components:{  }
}
</script>
